import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setError, setFulfilled, setPending, withRequestStatus } from '@shared/state/request-status.feature';
import { pipe, switchMap, tap } from 'rxjs';
import { Article } from '../model/article.model';
import { CMSResponse } from '../model/cms-response.model';
import { KnowledgeService } from '../service/knowledge.service';

export const ArticleDetailsStore = signalStore(
  withDevtools('article-details'),
  withState({
    data: null as CMSResponse<Article> | null,
  }),
  withRequestStatus(),
  withMethods((store, knowledgeService = inject(KnowledgeService), router = inject(Router)) => ({
    load: rxMethod<string>(
      pipe(
        tap(() => updateState(store, '[ArticleDetailsStore] Set pending', setPending())),
        switchMap((slug: string) =>
          knowledgeService.getArticleDetails(slug).pipe(
            tapResponse({
              next: (data) => {
                updateState(store, '[ArticleDetailsStore] Set fulfilled', setFulfilled());
                updateState(store, '[ArticleDetailsStore] Set data', { data });
              },
              error: () => {
                updateState(store, '[ArticleDetailsStore] Set error', setError());
                updateState(store, '[ArticleDetailsStore] Set data', { data: null });

                router.navigate(['/knowledge']);
              },
            }),
          ),
        ),
      ),
    ),
  })),
);
